import { useAuth } from 'common-react/auth/AuthProvider';
import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

export const AuthGuard: React.FC<PropsWithChildren<{ loginPath: string }>> = ({
  loginPath,
  children,
}) => {
  const { authStoreAccess } = useAuth();
  const jwtToken = authStoreAccess.useJwtToken();

  const isLoggedIn = !!jwtToken;

  if (!isLoggedIn) {
    return <Navigate to={loginPath} replace={true} />;
  }

  return children;
};
